import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { getWeddingConfig } from '../services/wedding-config';

const DressCodeAndGifts: React.FC = () => {
  const config = getWeddingConfig();
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <section className="dress-code-gifts-section">
      {/* Background with gradient using existing palette */}
      <div className="dress-code-gifts-background">
        <div className="dress-code-gifts-background-overlay"></div>
      </div>

      {/* Header */}
      <div className="dress-code-gifts-header">
        <h1 className="dress-code-gifts-subtitle">
          DETALLES IMPORTANTES
        </h1>
        {/* <h2 className="dress-code-gifts-title-script">
          Para Tu Comodidad
        </h2> */}
      </div>

      {/* Content */}
      <div className="dress-code-gifts-content">
        {/* Dress Code Card */}
        <div className="info-card dress-code-card">
          {/* <div className="info-card-icon">👔</div> */}
          <h3 className="info-card-title">¡Vístanse de Fiesta!</h3>
          {/* <p className="info-card-subtitle">{config.additionalInfo.dressCode.description}</p> */}
          <div className="info-card-details">
              <div className="divider-small"></div>
              <p className="info-card-text">
              Queremos que la celebración sea especial, así que les pedimos que nos acompañen con su VESTIMENTA FORMAL preferida.
              </p>
              <p className="info-card-text">
Les agradeceremos que, al elegir su atuendo, opten por colores distintos al color blanco, ya que este color está reservado para la novia.
</p>
              <p className="info-card-text">
¡Estamos listos para verlos en este día tan especial!      </p>
              <div className="divider-small"></div>
            </div>
          {/* {config.additionalInfo.dressCode.detailedInfo && (
            <div className="info-card-details">
              <div className="divider-small"></div>
              <p className="info-card-text">{config.additionalInfo.dressCode.detailedInfo}</p>
            </div>
          )} */}
        </div>

        {/* Gifts Card with Flip Effect */}
        <div className="flip-card-container">
          <motion.div
            className={`flip-card ${isFlipped ? 'flipped' : ''}`}
            animate={{ rotateY: isFlipped ? 180 : 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            style={{ transformStyle: "preserve-3d" }}
          >
            {/* Front Side */}
            <div className="flip-card-face flip-card-front">
              <div className="info-card gifts-card">
                <h3 className="info-card-title">Nuestro Cofre de Sueños</h3>
                <p className="info-card-subtitle">Querida familia y amigos</p>
                <div className="info-card-details">
                  <div className="divider-small"></div>
                  <p className="info-card-text">
                    Lo que más nos emociona es poder compartir este día tan importante con ustedes.
                  </p>
                  <p className="info-card-text">
                    Si además desean hacernos un regalo, hemos preparado un espacio especial donde podrán dejar su aporte económico y así apoyarnos a seguir sumando kilómetros en nuestro viaje de vida.
                  </p>
                  <p className="info-card-text">
                    Su compañía es invaluable, y su contribución para esta nueva aventura es un regalo que atesoraremos!
                  </p>
                  <div className="divider-small"></div>
                  <p className="info-card-text">
                    Con cariño,
                  </p>
                  <p className="info-card-text">
                    Lila y Quendal.
                  </p>
                </div>

                {/* <motion.button
                  className="flip-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFlip();
                  }}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  aria-label="Ver información bancaria"
                >
                  <motion.svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                  >
                    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                  </motion.svg>
                </motion.button> */}

              </div>
            </div>

            {/* Back Side */}
            <div className="flip-card-face flip-card-back">
              <div className="info-card gifts-card">
                <h3 className="info-card-title">...O si prefieres</h3>
                <p className="info-card-subtitle">Dejamos una cuenta bancaria para tu aporte 😄</p>
                <div className="info-card-details">
                  <div className="divider-small"></div>
                  <div className="bank-info">
                    <p className="bank-info-label">Banco:</p>
                    <p className="bank-info-value">BAM</p>

                    <p className="bank-info-label">Tipo de cuenta:</p>
                    <p className="bank-info-value">Monetaria - Quetzales</p>

                    <p className="bank-info-label">Número de cuenta:</p>
                    <p className="bank-info-value">30-1046756-7</p>

                    <p className="bank-info-label">Titular:</p>
                    <p className="bank-info-value">Lila Naomy Chonay Mérida</p>
                  </div>
                  <div className="divider-small"></div>
                  <p className="info-card-text" style={{ fontSize: '0.95rem', opacity: 0.8 }}>
                    ¡Gracias por tu generosidad!
                  </p>
                </div>

                <motion.button
                  className="flip-card-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFlip();
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Volver
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom spacing */}
      <div className="dress-code-gifts-bottom"></div>
    </section>
  );
};

export default DressCodeAndGifts;
